import React from 'react';
import Meta from '../components/Meta';

const Privacy = () => {
  return (
    <div>
      <Meta title="Terms of Use - Software Talks"/>

      <div className="pt-[5.5rem] lg:pt-8">
        <section className="dark:bg-jacarta-800 relative py-16 md:py-24">
          <picture className="pointer-events-none absolute inset-0 -z-10 dark:hidden">
            <img src="/images/gradient_light.jpg" alt="gradient" className="h-full w-full"/>
          </picture>
          <div className="container">
            <h1 className="font-display text-jacarta-700 text-center text-4xl font-medium dark:text-white">
              Privacy
            </h1>
            <h2 className="text-center">Updated October 20, 2019</h2>
            <div className="article-content mx-auto max-w-[48.125rem]">
              <p>This policy applies to all information collected or submitted during use of SoftwareTalks's website.</p>


              <h2>Highlights</h2>
              <ul>
                <li>SoftwareTalks never save personal data from the users.</li>
                <li>All data collected is necessary for the operation of the service.</li>
                <li>Your account can be deleted at any time via the account page.</li>
              </ul>
              <h2>Analytics</h2>
              <p>We use Google Analytics to get stats about how the users use the website.</p>


              <h2>Emails</h2>
              <p>We use an IMAP server to send emails. We are not using any third-party service.</p>


              <h2>Cookies and Tracking</h2>
              <p>We do not engage in or support cross-service tracking and do not use third party analytics packages.</p>


              <h2>Your Responsibilities for Protecting Your Data</h2>
              <p>When you create an SoftwareTalks account you create a password. For your protection, you should create a strong and unique password to ensure that it is not easily guessed. You should
                also keep a copy in a safe place because future access to your Secure Data depends on your password.</p>

              <p>We will never ask you for your password at any time and you should never send it to us.</p>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default Privacy;
